import { createRequestTypes } from 'common/websocket-redux';

export const REQUEST_RESUBMIT_REFUND_CLAIM = createRequestTypes(
  'script-helpers/RESUBMIT_REFUND_CLAIM',
);
